import produce from 'immer';
import {
    OverlayAction,
    OverlayContent,
} from './enum';
import { OverlayState } from './interface';
import { Actions } from './action';

export const initialState: OverlayState = {
    loadingStatus: {},
    isLoaded: false,
    isOpen: false,
    activeContent: OverlayContent.AVC,
};

const overlayReducer = (state: OverlayState = initialState, action: Actions) =>
    produce(state, draft => {
        switch (action.type) {
            case OverlayAction.LOADED:
                draft.isLoaded = true;
                break;
            case OverlayAction.SET_OVERLAY_VISIBILITY:
                draft.isOpen = action.isVisible;
                draft.activeContent = action.activeContent;
                break;
            case OverlayAction.SET_OVERLAY_CONTENT:
                draft.activeContent = action.activeContent;
                break;
            case OverlayAction.START_LOADING:
                draft.loadingStatus[action.id] = true;
                break;
            case OverlayAction.STOP_LOADING:
                delete draft.loadingStatus[action.id];
                break;
        }
    });

export default overlayReducer;
